import { generateMetaHead } from '~/utils/head';
export default {
  components: {},
  layout: '_base',
  head() {
    return generateMetaHead({
      routePath: this.$route.path
    });
  }
};